export function generateFilter(data, keyPath) {
  return (
    data &&
    data.reduce((accumulator, item) => {
      const value = keyPath.reduce((obj, key) => (obj && obj[key] ? obj[key] : null), item);
      const existingItem = accumulator.find((filterItem) => filterItem.text === value);

      if (existingItem) {
        existingItem.value = value;
      } else if (value) {
        accumulator.push({
          text: value,
          value,
        });
      }

      return accumulator;
    }, [])
  );
}

export function generateFilterNumbers(data, keyPath) {
  return (
    data &&
    data.reduce((accumulator, item) => {
      const value = keyPath.reduce((obj, key) => (obj && obj[key] ? obj[key] : null), item);
      const existingItem = accumulator.find((filterItem) => filterItem.text === value.toString());

      if (existingItem) {
        existingItem.value = value;
      } else if (value !== null && value !== undefined) {
        // Checking for both null and undefined
        accumulator.push({
          text: value.toString(), // Convert value to string
          value,
        });
      }

      return accumulator;
    }, [])
  );
}
